import Box from "@mui/material/Box";
import { scrollContainerSx, sectionContainerSx } from "./ContactSection.sx";
import Footer from "../Layout/Footer";
import { EmailCaptureForm } from "../EmailCaptureForm";

export interface ContactSectionProps {}

export const ContactSection = ({}: ContactSectionProps) => {
  return (
    <Box component="section" id="contact" sx={scrollContainerSx}>
      <Box id="/contact" sx={{ height: 0, overflow: "hidden" }} />
      <Box sx={sectionContainerSx}>
        <EmailCaptureForm />
      </Box>
      <Footer />
    </Box>
  );
};

export default ContactSection;
